export default {"src":"/_next/static/media/logo-wide-white.580357a3.svg","height":332,"width":1330,"blurWidth":0,"blurHeight":0};